if (!customElements.get('blog-content-carousel')) {
  customElements.define('blog-content-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.initVideos();
      const mobile = window.matchMedia('(max-width: 767px)');
      const init = () => {
        if (mobile.matches) {
          this.swiper?.destroy(true, true);
          this.swiper = null;
          return;
        }
        if (!this.isConnected || this.swiper || !window.Swiper) return;
        this.swiper = new Swiper(this.querySelector('.blog-swiper'), {
          slidesPerView: 3,
          spaceBetween: 24,
          slidesPerGroup: 1,
          loop: false,
          pagination: { el: this.querySelector('.swiper-pagination'), clickable: true },
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev')
          },
          breakpoints: {
            0: { slidesPerView: 1, spaceBetween: 20 },
            768: { slidesPerView: 2, spaceBetween: 16 },
            1024: { slidesPerView: 3, spaceBetween: 24 }
          }
        });
      };
      init();
      mobile.addEventListener('change', init, { signal: this.controller.signal });
      if (!this.swiper) window.addEventListener('load', init, { once: true, signal: this.controller.signal });
    }
    initVideos() {
      this.videos = Array.from(this.querySelectorAll('.blog-card__video video'));
      if (!this.videos.length) return;
      const signal = this.controller.signal;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const viewportVideos = new Set();
      const slideVideos = new Set();
      const update = (video) => {
        const visible = viewportVideos.has(video) && slideVideos.has(video) && !document.hidden;
        if (!visible) {
          video.pause();
          return;
        }
        if (reducedMotion.matches) return;
        if (video.paused) {
          video.muted = true;
          video.play().then(() => {
            if (!this.isConnected || document.hidden || !viewportVideos.has(video) || !slideVideos.has(video)) video.pause();
          }).catch(() => {
            // Native controls and the poster remain available when autoplay is blocked.
          });
        }
      };
      if (!('IntersectionObserver' in window)) return;
      const observeVisibility = (visibleVideos, options) => new IntersectionObserver((entries) => {
        entries.forEach(({ target, isIntersecting, intersectionRatio }) => {
          if (isIntersecting && intersectionRatio >= 0.25) visibleVideos.add(target);
          else visibleVideos.delete(target);
          update(target);
        });
      }, { threshold: [0, 0.25], ...options });
      this.videoViewportObserver = observeVisibility(viewportVideos, {});
      this.videoSlideObserver = observeVisibility(slideVideos, { root: this.querySelector('.blog-swiper') });
      this.videos.forEach((video) => {
        this.videoViewportObserver.observe(video);
        this.videoSlideObserver.observe(video);
      });
      document.addEventListener('visibilitychange', () => this.videos.forEach(update), { signal });
      reducedMotion.addEventListener('change', () => {
        this.videos.forEach((video) => {
          if (reducedMotion.matches) video.pause();
          else update(video);
        });
      }, { signal });
    }
    disconnectedCallback() {
      this.videoViewportObserver?.disconnect();
      this.videoSlideObserver?.disconnect();
      this.videos?.forEach((video) => video.pause());
      this.swiper?.destroy(true, true);
      this.swiper = null;
      this.controller?.abort();
      this.controller = null;
    }
  });
}
